export default "__VITE_ASSET__Dyw0IOU2__"